export default __webpack_public_path__ + "content/media/20.d2d3e135.jpg";